import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

interface CustomNodeData {
  name: string;
  position: string;
  initials: string;
  avatar?: string;
  type?: 'main' | 'sub';
}

const CustomNode: React.FC<NodeProps<CustomNodeData>> = ({ data }) => {
  const isMain = data.type === 'main';

  return (
   <div
  className={`relative bg-white ${isMain ? 'w-80 h-44 sm:w-80 sm:h-44' : 'w-52 h-38 sm:w-52 sm:h-38'} ${isMain ? 'max-sm:w-64 max-sm:h-44' : 'max-sm:w-44 max-sm:h-40'} p-2 flex flex-col items-center justify-center rounded-3xl border border-navgreen border-t-white border-l-white shadow-[0_0_4px_0_#00000040] border-b-[10px] border-r-[10px]`}
>

      {/* Top Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="w-0 h-0 bg-transparent border-none -top-2 left-1/2 transform -translate-x-1/2 pointer-events-none"
      />

      {/* Avatar */}
      <div className={`rounded-full bg-white flex items-center justify-center overflow-hidden mb-2 ${isMain ? 'w-12 h-12' : 'w-12 h-12'} ${isMain ? 'max-sm:w-12 max-sm:h-12' : 'max-sm:w-10 max-sm:h-10'}`}>
        {data.avatar ? (
          <img
            src={data.avatar}
            alt={data.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-xl font-bold text-gray-700">{data.initials}</span>
        )}
      </div>

      {/* Name */}
  <h3
  className={`font-semibold text-sm ${
    isMain ? 'text-xl' : 'text-base'
  } text-black ${
    isMain
      ? 'max-sm:text-sm max-sm:font-semibold'
      : 'max-sm:text-xs max-sm:font-medium'
  } mb-1 text-center leading-tight px-1`}
>
  {data.name}
</h3>


     <p
  className={`mb-2 font-medium text-xs ${
    isMain ? 'text-base' : 'text-sm'
  } ${isMain ? 'text-deepTeal font-medium text-sm' : 'text-black'} ${
    isMain ? 'max-sm:text-xs' : 'max-sm:text-[10px]'
  } text-center leading-tight px-1`}
>
  {data.position}
</p>


      {/* User Icon */}
      <div className="rounded-full flex items-center justify-center mx-auto mt-1">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center ${isMain ? 'max-sm:w-5 max-sm:h-5' : 'max-sm:w-4 max-sm:h-4'}`}>
          <img src="assets/org-user-one.svg" alt="user-icon" className="w-full h-full" />
        </div>
      </div>

      {/* Bottom Handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="w-0 h-0 bg-transparent border-none -bottom-2 left-1/2 transform -translate-x-1/2 pointer-events-none"
      />
    </div>
  );
};

export default CustomNode;